/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

// import logo from "images/Logo.svg";

import React from "react";

import Context from "lib/context";

import { Route } from "react-router-dom";
import * as types from "./AuthRoute.types";

export default class AuthRoute extends React.Component<types.AuthRotueProps> {

   static contextType = Context;
   public context!: types.AuthRouteContext;

   private hasRequiredRoles(): boolean {

      if (!this.context.api.auth) return false;

      const roles: string[] = this.context.api.auth.getCurrentUserRoles();

      if (!roles) return false;
      if (this.props.requiredRoles.length === 0) return true;

      let andRoles = true;

      this.props.requiredRoles.forEach(
         and => {
            let orRoles = false;
            and.forEach(
               or => orRoles = orRoles || roles.indexOf(or) !== -1
            );
            andRoles = andRoles && orRoles;
         }
      )

      return andRoles;

   }

   render() {

      return (

         <Route
            exact={this.props.exact}
            path={this.props.path}
            render={

               () => {
                  if (this.hasRequiredRoles())
                     return (
                        <this.props.component {...this.props} />
                     )
                  else

                     this.context.api.auth?.login("/");

                     return(<></>);

                     /*
                     return (

                        <div style={{position: "fixed", top: "10%", left: "50%", transform: "translateX(-50%)", textAlign: "center"}}>

                           <div style={{ width: "100%", height: "180px", background: `center no-repeat url(${logo}) ` }}>
                           </div>

                           <h1>Unauthorized!</h1>

                           <p>You have tried to access a protected resource without an authorization.</p>

                           <br/>

                           <p>You can try to <a style={{color: "white", fontWeight: "bold"}} href="/" onClick={(e) => { this.context.api.auth?.login(this.props.location!.pathname + this.props.location!.search); e.preventDefault(); }}>sign-in</a> to access this resource.</p>

                           <p>If you have no the CVE Radar account yet, you can sign-up from the <a style={{color: "white", fontWeight: "bold"}} href="/">main page</a> of the application.</p>

                        </div>

                     )
                     */

               }

            }
         />

      );

   }


}

